<div
    class="page-layout-container"
    #container
    [ngClass]="{ 'fit-height': fitHeight }"
>
    <ng-content
        select="app-page-header"
        #header
    />

    <div class="page-content">
        <ng-content select="[appBeforeTable]" />

        <div class="app-table-container">
            <ng-content select="app-table,[appTable]" />
        </div>

        <ng-content />
    </div>

    <ng-content select="app-paginator" />
</div>
